import { setBrowserCookie } from '@backmarket/utils/cookies/setBrowserCookie'

import { getOptionalTrackers } from '../../utils/getOptionalTrackers'

const EXPIRED_DATE = 'Thu, 01 Jan 1970 00:00:01 GMT'

function parseDocumentCookies(): Record<string, string> {
  return Object.fromEntries(
    document.cookie
      .split(';')
      .map((cookie) => cookie.trim())
      .filter(Boolean)
      .map((cookie) => {
        const separatorIndex = cookie.indexOf('=')

        return separatorIndex === -1
          ? [cookie, '']
          : [cookie.slice(0, separatorIndex), cookie.slice(separatorIndex + 1)]
      }),
  )
}

/**
 * Delete non-essential cookies readable from `document.cookie`.
 *
 * HTTP-only cookies are not visible here and are left to the
 * `/delete-cookies` server route. Removing regular cookies client-side first
 * reduces the number of Set-Cookie headers that route has to emit.
 *
 * Each cookie is cleared for the exact host, the market's apex domain and
 * without domain, mirroring the server route, since a cookie may have been
 * set on any of them.
 */
export function cleanBrowserCookies(marketDomain: string) {
  const cookiesToDelete = getOptionalTrackers(parseDocumentCookies())
  const possibleDomains = [window.location.hostname, marketDomain, undefined]

  cookiesToDelete.forEach((cookieName) => {
    possibleDomains.forEach((domain) => {
      setBrowserCookie(cookieName, '', {
        domain,
        path: '/',
        expires: EXPIRED_DATE,
      })
    })
  })
}
